// Formik
import { useFormik } from "formik";

// Libraries
import { useTranslation } from "react-i18next";

// Material UI
import { Button, InputAdornment, Stack, Typography } from "@mui/material";
import { MailOutline } from "@mui/icons-material";

// Validation
import { mbsSsoValidationSchema } from "Validation/UserValidation";

// Common
import { FormikTextField } from "Common/Components";

// Components
import MBSAuthFormHeader from "./MBSAuthFormHeader";

const MBSSSOForm = ({ onSubmit, onSignInWithEmail }) => {
  const { t } = useTranslation();
  const formik = useFormik({
    initialValues: { userEmail: "" },
    validationSchema: mbsSsoValidationSchema(t),
    onSubmit: async (values) => {
      await onSubmit(values.userEmail.trim());
    },
  });

  return (
    <Stack
      component="form"
      id="mbs-sso-form"
      noValidate
      onSubmit={formik.handleSubmit}
      spacing={3}
    >
      <MBSAuthFormHeader
        title={t("mbsAuth.ssoTitle")}
        description={t("mbsAuth.ssoDescription")}
      />

      <FormikTextField
        formik={formik}
        name="userEmail"
        field={{
          type: "email",
          label: t("mbsAuth.workEmail"),
          required: false,
          autoComplete: "email",
          slotProps: {
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <MailOutline />
                </InputAdornment>
              ),
            },
          },
        }}
      />

      <Stack spacing={2}>
        <Button
          type="submit"
          form="mbs-sso-form"
          variant="contained"
          disabled={formik.isSubmitting}
          fullWidth
        >
          {t("mbsAuth.continueWithWorkEmail")}
        </Button>
        <Typography variant="body2" textAlign="center">
          {t("mbsAuth.or")}
        </Typography>
        <Button
          type="button"
          variant="outlined"
          fullWidth
          onClick={onSignInWithEmail}
        >
          {t("mbsAuth.signInWithEmail")}
        </Button>
      </Stack>
    </Stack>
  );
};

export default MBSSSOForm;
